import * as React from 'react';

import PropTypes from 'prop-types';

import Icon from './Icon';

class ActionIcon extends React.Component {
  static propTypes = {
    row: PropTypes.object.isRequired,
    action: PropTypes.shape({
      icon: PropTypes.string,
      onClick: PropTypes.func,
      link: PropTypes.func,
      tooltip: PropTypes.string,
      style: PropTypes.string,
      target: PropTypes.string,
    }).isRequired,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message
    if (this.props.action.link) {
      return (
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message
        <div title={this.props.action.tooltip} className="btn btn-round btn-link">
          <a
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message
            href={this.props.action.link(this.props.row)}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message
            target={this.props.action.target || '_blank'}
            rel="noopener noreferrer"
          >
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message */}
            <Icon name={this.props.action.icon} style={this.props.action.style} />
          </a>
        </div>
      );
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message
    const onClick = () => this.props.action.onClick && this.props.action.onClick(this.props.row);
    return (
      <div
        className="btn btn-round btn-link"
        onClick={onClick}
        onKeyPress={onClick}
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message
        title={this.props.action.tooltip}
        role="button"
        tabIndex={0}
      >
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'Readonly... Remove this comment to see the full error message */}
        <Icon name={this.props.action.icon} style={this.props.action.style} />
      </div>
    );
  }
}

export default ActionIcon;
